module.exports = __webpack_public_path__ + "img/Bead Road.d2ea0084.png";